import { getAbbreviatedTimezoneName } from "@impero-com/common/utils/timezone";
import { Typography } from "antd";
import {
    FieldPathByValue,
    Control,
    FieldValues,
    useWatch,
} from "react-hook-form";
import { ZodDate } from "zod";

import { TimezoneTypeaheadValue } from "../fields/timezoneTypeaheadPopupInput";
import { RHFTimePickerInput } from "../rhfFields/rhfTimePickerInput";
import { RHFTimezoneTypeaheadPopupInput } from "../rhfFields/rhfTimezoneTypeaheadPopupInput";

import * as theme from "./theme.css";

const { Text } = Typography;

interface TimeAndTimezoneProps<TFieldsValues extends FieldValues> {
    control: Control<TFieldsValues>;
    timezoneInputName: FieldPathByValue<TFieldsValues, TimezoneTypeaheadValue>;
    timeInputSchema: ZodDate;
    disabled?: boolean;
    timeInputLabel: string;
    timeInputName: FieldPathByValue<TFieldsValues, Date>;
    readOnlyTimezone?: boolean;
}
export function TimeAndTimezone<TFieldsValues extends FieldValues>({
    control,
    timezoneInputName,
    timeInputSchema,
    timeInputLabel,
    timeInputName,
    disabled,
    readOnlyTimezone = false,
}: TimeAndTimezoneProps<TFieldsValues>) {
    return (
        <RHFTimePickerInput
            control={control}
            name={timeInputName}
            disabled={disabled}
            schema={timeInputSchema}
            label={timeInputLabel}
            nodeAfter={
                readOnlyTimezone ? (
                    <ReadOnlyTimezone
                        control={control}
                        timezoneInputName={timezoneInputName}
                    />
                ) : (
                    <RHFTimezoneTypeaheadPopupInput
                        control={control}
                        name={timezoneInputName}
                        disabled={disabled}
                    />
                )
            }
        />
    );
}

interface ReadOnlyTimezoneProps<TFieldsValues extends FieldValues> {
    control: Control<TFieldsValues>;
    timezoneInputName: FieldPathByValue<TFieldsValues, TimezoneTypeaheadValue>;
}
function ReadOnlyTimezone<TFieldsValues extends FieldValues>({
    control,
    timezoneInputName,
}: ReadOnlyTimezoneProps<TFieldsValues>) {
    const timezoneValue = useWatch({ control, name: timezoneInputName });

    return (
        <Text className={theme.timezoneText}>
            {getAbbreviatedTimezoneName(timezoneValue)}
        </Text>
    );
}
